require("./Toolbar.marko.scss");
"use strict";

var marko_template = module.exports = require("marko/dist/vdom").t(),
    marko_classValue = require("marko/dist/runtime/helpers/class-value"),
    marko_component = {
    onCreate: function () {
        this.state = {
            expandable: false,
            expanded: false
        };
        GState.bind(this, [
            'Extensions',
            'activeExtensions',
            'marketplace',
            'workspace',
            'notifications'
        ]);
    },
    onMount: function () {
        setTimeout(() => {
            if ($('#Toolbar > .apps-list').height() < $('#Toolbar > .apps-list > ul').height())
                this.state.expandable = true;
        }, 1000);
    },
    onToggle: function (id) {
        let action = 'open', values = Object.values(this.state.activeExtensions), maxIndex = Math.max(...values.map(({zindex}) => {
                return zindex;
            }));
        if (this.state.activeExtensions.hasOwnProperty(id) && this.state.activeExtensions[id].zindex == maxIndex)
            action = 'close';
        GState.extension[action](id);
        GState.marketplace.close();
        GState.notification.clear(id);
    },
    onExpand: function (status) {
        this.state.expanded = status;
    },
    onMarketPlace: function () {
        GState.marketplace[this.state.marketplace ? 'close' : 'open']();
    },
    onWorkspaceSwitch: function () {
        GState.workspace.layout({ mode: this.state.workspace.mode == 'qs' ? 'hs' : 'qs' });
    },
    onWorkspaceFullScreen: function () {
        GState.workspace.layout({ mode: this.state.workspace.mode !== 'fs' ? 'fs' : 'auto' });
    }
},
    components_registry_browser = require("marko/dist/runtime/components/registry-browser"),
    marko_registerComponent = components_registry_browser.r,
    marko_componentType = marko_registerComponent("/MP.WEB$2.0/src/views/smoothy~1.0/components/Toolbar.marko", function() {
      return module.exports;
    }),
    marko_renderer = require("marko/dist/runtime/components/renderer"),
    marko_defineComponent = require("marko/dist/runtime/components/defineComponent"),
    marko_forIn = require("marko/dist/runtime/helpers/for-in"),
    marko_assign = require("marko/dist/runtime/helpers/assign"),
    Favicon_template = require("./Favicon.marko"),
    marko_loadTag = require("marko/dist/runtime/helpers/load-tag"),
    Favicon_tag = marko_loadTag(Favicon_template),
    Bx_template = require("../../components/Bx/index.marko"),
    Bx_tag = marko_loadTag(Bx_template),
    marko_loadNestedTag = require("marko/dist/runtime/helpers/load-nested-tag"),
    Row_col_nested_tag = marko_loadNestedTag("col", 1),
    marko_mergeNestedTagsHelper = require("marko/dist/runtime/helpers/merge-nested-tags"),
    Row_template = require("../../components/Row/index.marko"),
    Row_tag = marko_loadTag(Row_template),
    subscribe_template = require("@marko-tags/subscribe/index.marko"),
    subscribe_tag = marko_loadTag(subscribe_template),
    marko_attrs0 = {
        "class": "theme-bg-primary",
        id: "Toolbar"
      },
    marko_attrs1 = {
        "class": "apps-list position-relative h-75 overflow-hidden"
      },
    marko_attrs2 = {
        "class": "h-25 d-flex align-items-end justify-content-center"
      },
    marko_attrs3 = {
        "class": "list-unstyled p-0 m-0"
      },
    marko_attrs4 = {
        "class": "position-relative"
      },
    marko_attrs5 = {
        "class": "m-0 list-unstyled"
      },
    marko_attrs6 = {
        "class": "position-relative d-flex justify-content-center"
      },
    marko_attrs7 = {
        style: "margin-top:-12px",
        "class": "position-absolute top-0 right-0"
      },
    marko_attrs8 = {
        style: "padding:0.1rem 0.3rem",
        "class": "badge badge-danger font-small-2 round"
      },
    marko_attrs9 = {
        "class": "d-block position-absolute bottom-0 w-100 theme-bg-primary text-center cursor-pointer shadow-lg"
      },
    marko_attrs10 = {
        "class": "theme-bg-primary shadow-lg overflow-auto py-2",
        id: "Toolbar-max"
      },
    marko_attrs11 = {
        "class": "expand-li position-relative"
      },
    marko_attrs12 = {
        style: "margin-top:-12px",
        "class": "position-absolute top-0 right-0"
      },
    marko_attrs13 = {
        style: "padding:0.1rem 0.3rem",
        "class": "badge badge-danger font-small-2 round"
      };

function render(input, out, __component, component, state) {
  var data = input;

  out.be("div", marko_attrs0, "0", component);

  out.be("div", marko_attrs1, "1", component);

  if (state.Extensions && Object.keys(state.Extensions).length) {
    out.be("ul", marko_attrs5, "2", component);

    marko_forIn(state.Extensions, function(id, extension) {
      const 
      { name, favicon } = extension,
      isActive = state.activeExtensions.hasOwnProperty( id )

      var $keyValue$0 = "@" + ("toolbar-" + id),
          $keyScope$0 = "[" + ($keyValue$0 + "]");

      out.be("li", marko_attrs6, $keyValue$0, component, null, 0, {
          onclick: __component.d("click", "onToggle", false, [
              id
            ])
        });

      if ((!isActive) && state.notifications[id]) {
        out.e("span", marko_attrs7, "3" + $keyScope$0, component, 1)
          .e("span", marko_attrs8, "4" + $keyScope$0, component, 1)
            .t(state.notifications[id].length, component);
      }

      Favicon_tag(marko_assign({
          width: 42,
          asTitle: "name",
          class: marko_classValue([
            "cursor-pointer",
            isActive ? "bg-active" : ""
          ])
        }, extension), out, __component, "5" + $keyScope$0);

      out.ee();
    });

    out.ee();

    out.t(" ");
  }

  if (state.expandable) {
    out.be("span", marko_attrs9, "6", component, null, 0, {
        onclick: __component.d("click", "onExpand", false, [
            true
          ])
      });

    Bx_tag({
        type: "dots-horizontal-rounded",
        class: "font-large-1 py-1"
      }, out, __component, "7");

    out.ee();
  }

  out.ee();

  out.be("div", marko_attrs2, "8", component);

  out.be("ul", marko_attrs3, "9", component);

  out.be("li", marko_attrs4, "10", component);

  out.be("span", {
      "class": "bg-active theme-bg-primary cursor-pointer",
      title: Locale((state.marketplace ? "Close" : "Open") + " Marketplace")
    }, "11", component, null, 0, {
      onclick: __component.d("click", "onMarketPlace", false)
    });

  Bx_tag({
      type: state.marketplace ? "x" : "grid-alt"
    }, out, __component, "12");

  out.ee();

  out.ee();

  out.be("li", {
      "class": marko_classValue(marko_classValue([
        "position-relative",
        (!Object.keys(state.activeExtensions).length) && (!state.marketplace) ? "d-none" : "d-sm-block d-none"
      ]))
    }, "13", component, null, 1);

  const isQuaterScreen = state.workspace.mode == 'qs'

  out.be("span", {
      "class": "bg-active cursor-pointer",
      title: Locale(isQuaterScreen ? "Half Screen" : "Quarter Screen")
    }, "14", component, null, 0, {
      onclick: __component.d("click", "onWorkspaceSwitch", false)
    });

  Bx_tag({
      type: "dock-" + (isQuaterScreen ? "left" : "right"),
      class: "white-text"
    }, out, __component, "15");

  out.ee();

  out.ee();

  out.be("li", {
      "class": marko_classValue(marko_classValue([
        "position-relative",
        (!Object.keys(state.activeExtensions).length) && (!state.marketplace) ? "d-none" : ""
      ]))
    }, "16", component, null, 1);

  const isFullScreen = state.workspace.mode == 'fs'

  out.be("span", {
      "class": "bg-active cursor-pointer",
      title: Locale(isFullScreen ? "Exit Full Screen" : "Full Screen")
    }, "17", component, null, 0, {
      onclick: __component.d("click", "onWorkspaceFullScreen", false)
    });

  Bx_tag({
      type: (isFullScreen ? "exit-" : "") + "fullscreen",
      class: "white-text"
    }, out, __component, "18");

  out.ee();

  out.ee();

  out.ee();

  out.ee();

  out.ee();

  if ((state.expanded && state.Extensions) && Object.keys(state.Extensions).length) {
    out.be("div", marko_attrs10, "19", component);

    Row_tag(marko_mergeNestedTagsHelper({
        class: "m-0",
        renderBody: function(out, $nestedTagRow$0) {
          var $for$0 = 0;

          marko_forIn(state.Extensions, function(id, extension) {
            var $keyScope$1 = "[" + (($for$0++) + "]");

            Row_col_nested_tag({
                class: "col-lg-3 col-4",
                renderBody: function(out) {
                  const
                  { name, favicon } = extension,
                  isActive = state.activeExtensions.hasOwnProperty( id )

                  out.be("div", marko_attrs11, "@" + ("toolbar-" + id), component, null, 0, {
                      onclick: __component.d("click", "onToggle", false, [
                          id
                        ])
                    });

                  if ((!isActive) && state.notifications[id]) {
                    out.e("span", marko_attrs12, "22" + $keyScope$1, component, 1)
                      .e("span", marko_attrs13, "23" + $keyScope$1, component, 1)
                        .t(state.notifications[id].length, component);
                  }

                  Favicon_tag(marko_assign({
                      width: 44,
                      asTitle: "name",
                      class: marko_classValue([
                        "cursor-pointer",
                        isActive ? "bg-active" : ""
                      ])
                    }, extension), out, __component, "24" + $keyScope$1);

                  out.ee();
                }
              }, $nestedTagRow$0);
          });
        }
      }), out, __component, "20");

    out.ee();

    subscribe_tag({
        to: document,
        __events: [
          "on",
          "click"
        ]
      }, out, __component, "25", [
      [
        "click",
        "onExpand",
        false,
        [
            false
          ]
      ]
    ]);
  }
}

marko_template._ = marko_renderer(render, {
    e_: marko_componentType
  }, marko_component);

marko_template.Component = marko_defineComponent(marko_component, marko_template._);
